import { authContext } from "index";
import { useContext } from "react";

export const useAuth = () => {
  return useContext(authContext);
};
